import type { ComponentStyleConfig } from '@chakra-ui/theme';

export const Text: ComponentStyleConfig = {
  variants: {
    tableData: {
      fontSize: '14',
    },
  },
};
